import React from 'react'

const App = () => {
  return (
    <div>
      Hello World
    </div>
  )
}

export default App
